export default {
  change: 'Change',
  resetPassword: 'Reset Password',
  cancelEdit: 'Cancel Edit',
  editInfo: 'Edit Info',
  userId: 'User ID',
  email: 'Email',
  phone: 'Phone',
  company: 'Company',
  lastLogin: 'Last Login',
  registerTime: 'Register Time',
  save: 'Save Changes',
  cancel: 'Cancel',
  thirdPartyBind: 'Third-party Account Binding',
  notBound: 'Not Bound',
  bound: 'Bound',
  unbound: 'Unbound',
  unbind: 'Unbind',
  toBind: 'Bind Now',
  verifyMethod: 'Verification Method',
  phoneVerify: 'Phone Verification',
  emailVerify: 'Email Verification',
  code: 'Verification Code',
  sendCode: 'Send Code',
  newPassword: 'New Password',
  confirmPassword: 'Confirm New Password',
  username: 'Username',
  needVerify: 'Need Verification',
  passwordMin: 'Password must be at least 6 characters',
  passwordNotMatch: 'Passwords do not match',
  validPhone: 'Please enter a valid phone number',
  inputUsername: 'Please enter username',
  usernameMin: 'Username must be at least 2 characters',
  usernameMax: 'Username cannot exceed 50 characters',
  inputEmail: 'Please enter email',
  validEmail: 'Please enter a valid email address',
  emailMax: 'Email cannot exceed 100 characters',
  inputPhone: 'Please enter phone number',
  phoneMax: 'Phone number cannot exceed 20 characters',
  inputCompany: 'Please enter company',
  inputCode: 'Please enter verification code',
  inputNewPassword: 'Please enter new password',
  inputConfirmPassword: 'Please confirm new password',
  updateSuccess: 'User info updated successfully',
  updateFail: 'Failed to update user info',
  fetchFail: 'Failed to fetch user info',
  sendCodeFail: 'Failed to send code',
  resetSuccess: 'Password reset successfully',
  resetFail: 'Failed to reset password',
  avatarTodo: 'Avatar upload feature to be implemented',
  avatarTypeError: 'Please select an image file',
  avatarSizeError: 'Avatar file size cannot exceed 5MB',
  avatarUploadSuccess: 'Avatar uploaded successfully',
  avatarUploadFail: 'Failed to upload avatar',
  superAdmin: 'Super Admin',
  user: 'User',
  statusActive: 'Active',
  statusInactive: 'Inactive',
  statusPending: 'Pending',
  verifyTitle: 'Verify',
  verifyStepSend: 'Send Code',
  verifyStepCheck: 'Verify Identity',
  verifySendTip: 'Detected that you changed your {field}. You need to verify the new {field} to save changes.',
  verifySendTo: 'A code will be sent to the following {field}:',
  verifyCodeLabel: 'Verification Code',
  verifyCodePlaceholder: 'Please enter 6-digit code',
  verifyCodeSent: 'Code sent',
  verifyResend: 'Resend in {countdown}s',
  verifyResendBtn: 'Resend',
  verifyAndSave: 'Verify and Save',
  verifySuccess: 'Verification successful',
  verifyFail: 'Incorrect code',
  verifySendSuccess: 'Code sent to {target}',
  verifyNext: 'Next',
  verifyPrev: 'Previous',
  verifyCancel: 'Cancel',
  personalEmailTitle: 'Personal Sender Email',
  personalEmailTip: 'When a template selects Operator Personal Email, messages use this SMTP configuration and your profile email address as the sender.',
  personalEmailSender: 'Sender Email',
  personalEmailSenderName: 'Sender Name',
  personalEmailSenderNamePlaceholder: 'Uses your profile name when empty',
  personalEmailSenderNameMaxLength: 'Sender name cannot exceed 100 characters',
  personalEmailSmtpServer: 'SMTP Server',
  personalEmailSmtpServerRequired: 'Please enter the SMTP server',
  personalEmailSmtpServerMaxLength: 'SMTP server cannot exceed 255 characters',
  personalEmailSmtpPort: 'SMTP Port',
  personalEmailSmtpPortRequired: 'Please enter the SMTP port',
  personalEmailEncryption: 'Encryption',
  personalEmailSmtpAccount: 'SMTP Account',
  personalEmailSmtpAccountPlaceholder: 'Uses sender email when empty',
  personalEmailSmtpAccountMaxLength: 'SMTP account cannot exceed 255 characters',
  personalEmailSmtpPassword: 'SMTP Password / App Code',
  personalEmailSmtpPasswordRequired: 'Please enter the SMTP password or app code',
  personalEmailSmtpPasswordMaxLength: 'SMTP password or app code cannot exceed 500 characters',
  personalEmailSmtpPasswordPlaceholder: 'Enter SMTP password or app code',
  personalEmailSmtpPasswordSaved: 'Saved; leave empty to keep it unchanged',
  personalEmailStatus: 'Enable Personal Email',
  personalEmailSignatureEnabled: 'Enable Signature',
  personalEmailSignature: 'Email Signature (HTML)',
  personalEmailSave: 'Save Personal Email',
  personalEmailTest: 'Send Test Email',
  personalEmailNotTested: 'Not Tested',
  personalEmailTestSuccess: 'Test Passed',
  personalEmailTestFailed: 'Test Failed',
  personalEmailFetchFailed: 'Failed to load personal email settings',
  personalEmailSaveSuccess: 'Personal email settings saved',
  personalEmailSaveFailed: 'Failed to save personal email settings',
  personalEmailTestMailSent: 'A test email was sent to your mailbox'
}
